export default __webpack_public_path__ + "static/Richard.Colburn_v2_social-3087eda650e5e97701f356f81f6a6154.jpg";